export function getStatParams(activity) {
  let { relevance, coin } = {};
  switch (activity.type) {
    case 'upvote':
    case 'partialUpvote':
    case 'downvote':
    case 'partialDownvote':
      relevance = true;
      break;
    case 'vote':
    case 'basicIncome':
      coin = true;
      break;
    default:
      if (activity.coin) coin = true;
  }

  return { relevance, coin };
}

export function getActivityParams(activity) {
  const { post } = activity;
  let emoji;
  let userImage;
  let image;
  let byUser;

  switch (activity.type) {
    case 'upvote':
    case 'partialUpvote':
    case 'downvote':
    case 'partialDownvote':
    case 'reward_referral':
    case 'reward_referredBy':
    case 'reward_publicInvite':
    case 'reward_publicLink':
    case 'mention':
    case 'commentMention':
    case 'postMention':
      if (activity.byUser) userImage = activity.byUser;
      else emoji = '☺️';
      byUser = activity.byUser;
      break;
    case 'basicIncome':
    case 'reward':
    case 'reward_twitter':
    case 'reward_email':
    case 'reward_reddit':
      emoji = '☺️';
      break;
    case 'topPost':
      image = require('public/img/r-emoji.png');
      break;
    default:
      userImage = activity.byUser;
      byUser = activity.byUser;
      break;
  }

  return { emoji, userImage, post, image, byUser };
}
